export default function formattedPrice(cents) {
  return `€${cents / 100.0}`
}
